import autosize from "autosize";

export const initConversationTextareaCookieValue = () => {
  const conversation = document.getElementById("conversation") as HTMLDivElement;

  if (!conversation) {
    return;
  }

  const submitMessageForm = document.getElementById("submit-message-form") as HTMLFormElement;
  const textarea = submitMessageForm.querySelector("textarea") as HTMLTextAreaElement;
  const inboxId = conversation.dataset.inboxId;

  const textareaCookieValue = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`conversation-${inboxId}-textarea=`))
    ?.split("=")[1];

  /**
   * Display stored textarea value
   */
  if (textareaCookieValue && !textarea.value) {
    textarea.value = textareaCookieValue;

    autosize(textarea);
  }

  /**
   * Save textarea value to cookie, so we can put it back when the user returns to this page
   */
  const hostnameBase = window.location.hostname.replace(/^[^.]*./, "");
  textarea.addEventListener("keyup", () => {
    // biome-ignore lint/suspicious/noDocumentCookie: <Fix after all files will be refactored to biome rules>
    document.cookie =
      "conversation-" +
      inboxId +
      "-textarea=" +
      textarea.value +
      "; max-age=86400; path=/; domain=" +
      hostnameBase +
      "; secure; samesite=lax";
  });
};
